export const readHash = () => {
  const output = {
    styles: [{}, {}]
  };
  if (location.hash.length === 0) return output;
  location.hash
    .replace('#', '')
    .split('&')
    .forEach(kv => {
      const [key, value] = kv.split('=');
      const decodedValue = decodeURIComponent(value);

      if (key === 'styles') {
        JSON.parse(decodedValue).forEach((url, i) => {
          output.styles[i].url = url;
        });
      }
      else {
        output[key] = decodedValue;
      }
    });

  return output;
};

export const writeHash = (settings) => {
  let qs = '#';

  Object.entries(settings).forEach(([key, value]) => {
    if (key === 'styles' && !!value) {
      value = JSON.stringify(value.map(({ url }) => url).filter(v => !!v));
    }

    let encodedValue = encodeURIComponent(value);
    qs = `${qs}${qs !== '#' ? '&' : ''}${key}=${encodedValue}`;
  });

  window.location.hash = qs;
};
